/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { I18nService } from '@dm/core';
import { FeatureConfig } from 'app/config/feature';
import { type Observable } from 'rxjs';

import { HostsService } from '../../../../../../service/block-service/hosts/hosts.service';
import { GlobalSearchService } from '../../../../global-search.service';
import { DataTypeE } from '../../../../global-search-str.service';
import { type SearchParams } from '../../../const';
import { InfigoService } from '../../../infigo.service';
import { SourceEnumService } from '../../../source-enum.service';
import { RefreshComponent } from '../../RefreshComponent';

@Component({
    selector: 'app-host-base-info',
    templateUrl: './host-base-info.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HostBaseInfoComponent extends RefreshComponent {
    @Input() item;
    loading = true;
    detail: any = {};
    baseInfo;
    capacityPercentData = 0;
    usageValue = this.hostsService.usageValue;

    constructor(
        public infigoService: InfigoService,
        public hostsService: HostsService,
        public i18n: I18nService,
        public enumService: SourceEnumService,
        public global: GlobalSearchService,
        public changeDetectorRef: ChangeDetectorRef) {
        super();
        const I18N = i18n.get;
        const enumGet = enumService.get.bind(enumService, 'HOST');
        this.baseInfo = [
            {
                title: I18N('common.healthStatus_column'),
                key: 'HEALTHSTATUS',
                enumMap: enumGet('HEALTHSTATUS'),
            },
            {
                title: I18N('common.operatingSystem_lab'),
                key: 'OPERATIONSYSTEM',
                enumMap: enumGet('OPERATIONSYSTEM'),
            },
            {
                title: I18N('host.host_view_summary_belongedHostGroup_label'),
                key: 'PARENTNAME',
                templateName: 'Link',
                templateParams: {
                    link: (value): SearchParams[] | SearchParams => this.global.transform({ ID: value.PARENTID }, null, DataTypeE.hostGroup),
                },
            },
            {
                title: I18N('common.IPaddress_column'),
                key: 'IP',
            },
            {
                title: I18N('host.host_term_initiatorQuantity_lab'),
                key: 'INITIATORNUM',
            },
            ...(!FeatureConfig.IsSupportHostAccessMode ? [] : [
                {
                    title: I18N('protection.protectionGroup_task_createHyper_hostAccessMode_label'),
                    key: 'accessMode',
                    enumMap: enumGet('accessMode'),
                },
            ]),
        ];
    }

    requestInfo(): Observable<any> {
        return this.infigoService.getHost(this.item.actionParams);
    }

    handleRequest(value: any): void {
        this.detail = value.data;
        this.loading = false;
        this.clearTimer();
        this.updateLoading = false;
        this.changeDetectorRef.detectChanges();
    }
}
